import React, { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import cross from "../../src/assets/images/webchatbot/cross.png";
import send from "../../src/assets/images/webchatbot/send-ke.png";
import keLogo from "../../src/assets/images/webchatbot/botImage.png";
import downloadLogo from "../../src/assets/images/webchatbot/download-web.png";
import pdfLogo from "../../src/assets/images/webchatbot/pdf-web.png";
import typingDot from "../../src/assets/images/webchatbot/typing-dots.gif";
import tick from "../../src/assets/images/Tick.svg";
import {
  decryptedValueKE,
  encryptedValueKE,
} from "../../src/Utils/RouteHashConversion";
import axios from "axios";

var apiKeyWebKE = process.env.REACT_APP_BASEURL;
const apiPostKE = async (endPoint, onSuccess, onFailure, body) => {
  let token = await jwtKE();

  axios
    .post(apiKeyWebKE + endPoint, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (onSuccess) onSuccess(response?.data);
    })
    .catch((error) => {
      if (onFailure) onFailure(error);
    });
};

const jwtKE = async () => {
  try {
    const data = await localStorage.getItem("keToken");
    if (data !== null) {
      return data;
    }
  } catch (error) {}
};
const ChatWidget = () => {
  const [sessionId, setSessionId] = useState(null);
  // const [messagesData, setMessagesData] = useState([]);
  const [stepResponse, setStepResponse] = useState(0);
  const [inputMessage, setInputMessage] = useState("");
  const [buttonId, setButtonId] = useState(""); // Store button ID when clicked
  const [historyMessages, setHistoryMessages] = useState([]);
  const [loader, setLoader] = useState(true);
  const [lateResponseText, setLateResponseText] = useState("");

  const [time, setTime] = useState(true);
  const [typingLoading, SetTypingLoading] = useState(false);

  const inputMessageRef = useRef();
  const buttonIDRef = useRef();

  const generateSessionId = () => {
    const uniqueSessionId = uuidv4();
    setSessionId(uniqueSessionId);
  };

  const userMessage = (message, id = "", newStep, isFeedback) => {
    SetTypingLoading(true);

    let formData = new FormData();

    // Encrypt the values
    const encryptedSessionId = encryptedValueKE(sessionId);
    const encryptedId = encryptedValueKE(id === "" || id === null ? "" : id);
    const encryptedMessage = encryptedValueKE(message);
    const encryptedStep = encryptedValueKE(newStep);
    var encryptedFeedback = "";
    if (isFeedback) {
      encryptedFeedback = encryptedValueKE("True");
    }

    // Append encrypted values to the form data
    formData.append("sessionId", encryptedSessionId);
    formData.append("id", encryptedId);
    formData.append("message", encryptedMessage);
    formData.append("step", encryptedStep);
    if (isFeedback) {
      formData.append("feedback", encryptedFeedback);
    }

    apiPostKE(
      `/api/auth/v1/userMessage`,
      onSuccessUserMessage,
      onFailureUserMessage,
      formData
    );

    if (isFeedback) {
      // Open the link in a new tab
      window.open(isFeedback, "_blank", "noopener,noreferrer");
    }
  };

  const onSuccessUserMessage = (response) => {
    response = decryptedValueKE(response.edata);



    // console.log(response , " Response")
    // Transform the data
    var initialData = response.message;
    const transformedData = initialData.flatMap((item) => {
      if (item.feedbackForm) {
        // If feedbackForm exists, spread its contents
        return item.feedbackForm;
      }
      // Otherwise, keep the item as is
      return item;
    });
    if (response.code === 200) {
      setTimeout(() => {
        SetTypingLoading(false);
        setTime(response?.data?.timeStamp);
        if (
          response.status === "Fail" ||
          response.message === "Machine Learning Logic Here"
        ) {
          setHistoryMessages((prevMessages) => [
            ...prevMessages,
            {
              sent: "",
              received:
                response?.message?.[0]?.text ||
                response?.message ||
                "Machine Learning Logic, Press M for Main Menu",
            },
          ]);
        } else {
          setLoader(false);
          // const receivedMessages = response.message.map((msg, index, array) => {
          const receivedMessages = transformedData.map((msg, index, array) => {
            if (msg.type === "image" || msg.type === "pdf") {
              if (array[index + 1]) {
                array[index + 1].type = "duplicateMsg";
              }
            }
            const hasMonths = msg.months && msg.months.length > 0;
            const hasButtons = msg.button && msg.button.length > 0;
            const hasServices = msg.services && msg.services.length > 0;

            if (!msg.type || msg.type === "") {
              if (hasServices) {
                msg.type = "";
              } else if (hasMonths || hasButtons) {
                msg.type = "duplicateMsg";
              } else {
                const areAllEmpty =
                  (!msg.button || msg.button.length === 0) &&
                  (!msg.services || msg.services.length === 0) &&
                  (!msg.months || msg.months.length === 0);

                if (areAllEmpty) {
                  msg.type = "duplicateMsg";
                }
              }
            }

            return {
              sent: "",
              received: msg.text,
              type: msg.type,
              value: msg.value,
            };
          });

          const services = transformedData
            .filter((msg) => msg.service)
            .map((msg) => ({ _id: msg._id, service: msg.service }));

          const months = transformedData
            .filter((msg) => msg.month)
            .map((msg) => msg.month);

          const buttonsArray = transformedData
            .filter((msg) => msg.button && msg.answer)
            .map((msg) => ({
              button: msg.button,
              answer: msg.answer,
            }));

          const lastMessage = receivedMessages[receivedMessages.length - 1];
          const uniqueButtons = buttonsArray.filter(
            (buttonObj) =>
              !receivedMessages.some(
                (msg) => msg.button && msg.button === buttonObj.button
              )
          );

          if (uniqueButtons.length > 0) {
            lastMessage.button = uniqueButtons;
          }

          setHistoryMessages((prevMessages) => [
            ...prevMessages,
            ...receivedMessages.map((m) => ({
              received: m.received,
              button: m.button || uniqueButtons,
              services: services.length > 0 ? services : [],
              months: months,
              type: services.length > 0 ? "" : m.type,
              value: m.value,
            })),
          ]);

          // setMessagesData(response.message);
          setStepResponse(response.data.step);
          if (
            response?.data?.id === null ||
            response?.data?.id ||
            response.data.id === ""
          ) {
            setButtonId(response?.data?.id);
          }
        }
      }, 2000);
    }
  };

  const onFailureUserMessage = (error) => {
    // authAPI();
    if (error.status === 401) {
      generateSessionId();
      authAPI();
    }
    SetTypingLoading(false);
  };

  const authAPI = () => {
    let formData = new FormData();
    const username = process.env.REACT_APP_USERNAME;
    const password = process.env.REACT_APP_PASSWORD;

    formData.append("username", encryptedValueKE(username));
    formData.append("password", encryptedValueKE(password));

    apiPostKE(
      `/api/auth/v1/TokenGenerate`,
      onSuccessAuthAPI,
      onFailureAuthAPI,
      formData
    );
  };

  const onSuccessAuthAPI = (response) => {
    response = decryptedValueKE(response.edata);
    if (response.code === 200) {
      setLoader(false);


      localStorage.setItem("keToken", response.data.access_token);

      if (
        inputMessageRef.current === "Main Menu" ||
        inputMessageRef.current === "m" ||
        inputMessageRef.current === "M"
      ) {
        userMessage(null, null, 0);
      } else {
        userMessage(
          inputMessageRef.current || null,
          buttonIDRef.current || buttonId,
          stepResponse
        );
      }

      generateSessionId();
    }
  };

  const onFailureAuthAPI = (error) => {
    // console.log(error);
  };

  useEffect(() => {
    let timer;
    if (typingLoading) {
      timer = setTimeout(() => {
        setLateResponseText("Please wait while we process your request.");
      }, 10000);
    }

    return () => clearTimeout(timer); // Cleanup on unmount or state change
  }, [typingLoading]);

  const handleSelectMessage = (message, id) => {
    inputMessageRef.current = message;
    buttonIDRef.current = id;

    setButtonId(id);
    setHistoryMessages((prevMessages) => [
      ...prevMessages,
      { sent: message, received: "" },
    ]);
    const newStep = stepResponse;

    if (
      message === "Main Menu" ||
      inputMessageRef.current === "m" ||
      inputMessageRef.current === "M"
    ) {
      userMessage(null, null, 0);
    } else {
      userMessage(inputMessageRef.current, id || buttonIDRef.current, newStep);
    }
  };

  const handleSelectMessageMonth = (message) => {
    inputMessageRef.current = message;
    setHistoryMessages((prevMessages) => [
      ...prevMessages,
      { sent: message, received: "" },
    ]);
    const newStep = stepResponse;
    userMessage(inputMessageRef.current, buttonId, newStep);
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputMessage(newValue);
    inputMessageRef.current = newValue;
  };

  const handleSendMessage = () => {
    if (inputMessage) {
      const messageToSend = inputMessage;
      setHistoryMessages((prevMessages) => [
        ...prevMessages,
        { sent: messageToSend, received: "" },
      ]);
      setInputMessage("");

      const newStep = stepResponse;
      if (
        messageToSend === "m" ||
        inputMessageRef.current === "Main Menu" ||
        inputMessageRef.current === "M"
      ) {
        userMessage(messageToSend, null, 0);
      } else {
        userMessage(messageToSend, buttonId, newStep);
      }
    }
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleSelectMessageButton = (text, answer, isfeedbackButtonClick) => {
    inputMessageRef.current = answer;

    setHistoryMessages((prevMessages) => [
      ...prevMessages,
      { sent: text, received: "", answer },
    ]);

    const newStep = stepResponse;
    if (isfeedbackButtonClick) {
      userMessage(inputMessageRef.current, buttonId, newStep, answer);
    } else {
      userMessage(inputMessageRef.current, buttonId, newStep);
    }
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const hasAuthAPICalled = useRef(false);

  useEffect(() => {
    if (!hasAuthAPICalled.current) {
      authAPI();
      hasAuthAPICalled.current = true;
    }
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [historyMessages]);

  const convertTimestamp = (timestamp) => {
    const dt = new Date(timestamp);
    let hours = dt.getHours();
    const minutes = dt.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${formattedMinutes} ${ampm}`;
  };

  const getCurrentTime = () => {
    const currentDate = new Date();
    let hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${formattedMinutes} ${ampm}`;
  };
  const messagesEndRef = useRef(null);

  // Select both divs
  const leftsideKEFeedback = document.querySelectorAll(
    ".removeElementFeedback"
  );
  useEffect(() => {
    const leftsideKEElements = document.querySelectorAll(".leftsideKE");

    leftsideKEElements.forEach((el, index) => {
      if (el.classList.contains("removeElementFeedback")) {
        const previousSibling = leftsideKEElements[index - 1];

        if (previousSibling) {
          previousSibling.classList.add("previous-to-feedback");

          const chatBoxBtnMain =
            previousSibling.querySelector(".chatBoxBtnMain");
          if (chatBoxBtnMain) {
            chatBoxBtnMain.style.display = "none";
          }
        }
      }
    });
  }, [leftsideKEFeedback]);

  const handleClose = () => {
    window.parent.postMessage("closeWidget", "*");
  };

  return (
    <div id="customChatBox" className={`preview kechatbot open`}>
      <div className="preview-header">
        <img src={keLogo} alt="logo" className="preview-header-logo" />
        <div>
          <h3 className="md-headingKE">Kineto <span className=""><img src={tick}/></span> </h3>
          <p className="md-paragraph">Your 24/7 digital assistant</p>
        </div>
        <img
          src={cross}
          alt="close"
          className="preview-header-cross"
          onClick={handleClose}
        />
      </div>
      <div className="preview-body ">
        <div className="mainScroller">
          {historyMessages.map((message, index) => (
            <>
              {index === 0 ? (
                <div className="disclaimer-container">
                  <div className="disclaimer-heading">DISCLAIMER:</div>
                  <div className="disclaimer-text">
                    While KE strives to provide accurate information through the
                    chatbot, KE cannot guarantee the accuracy, completeness, or
                    up-to-date nature of the information provided therein. Users
                    are strongly advised to exercise caution when relying on the
                    generated responses and refrain from sharing any sensitive
                    or personal information. KE will not be held liable for any
                    consequences resulting from the use of this app or the
                    reliance on its responses.
                  </div>
                </div>
              ) : null}

              <div
                className={
                  message.type === "feedback"
                    ? "leftsideKE removeElementFeedback"
                    : message.type === "image" || message.type === "pdf"
                    ? "leftsideKE removeElement"
                    : "leftsideKE"
                }
                key={index}
              >
                <div className="chatBoxBody1">
                  {((message.services?.length > 0 && message.received) ||
                    (message.months?.length > 0 && message.received) ||
                    (message.button?.length > 0 && message.received) ||
                    message.received ||
                    message.value) && (
                    <div className="KEbot-sm">
                      <img
                        src={keLogo}
                        alt="logo"
                        className="preview-header-logo-sm"
                      />
                      <span className="smallest-text">Kineto</span>
                    </div>
                  )}
                </div>
                <div className="chatBoxBody2">
                  {loader && message.received === "" ? (
                    <img
                      src={typingDot}
                      alt="typing"
                      className="preview-header-cross"
                    />
                  ) : (
                    ((message.services?.length > 0 && message.received) ||
                      (message.months?.length > 0 && message.received) ||
                      (message.button?.length > 0 && message.received) ||
                      message.received ||
                      message.value) && (
                      <>
                        <div className="message-block">
                          {message.type === "pdf" ? (
                            <>
                              <div className="message receivedMsg">
                                <pre
                                  dangerouslySetInnerHTML={{
                                    __html: message.received,
                                  }}
                                ></pre>
                              </div>
                              <a href={message.value} download target="_blank" rel="noreferrer">
                                <div className="message receivedMsg">
                                  <img
                                    src={pdfLogo}
                                    alt="pdf logo"
                                    className="preview-header-logo-sm"
                                  />
                                  <pre>
                                    {(() => {
                                      const parts = message.value.split("/");
                                      const fileName = parts[parts.length - 1];
                                      return fileName;
                                    })()}
                                  </pre>
                                  <img
                                    src={downloadLogo}
                                    alt="download logo"
                                    className="preview-header-logo-sm"
                                  />
                                </div>
                              </a>
                            </>
                          ) : message.type === "image" ? (
                            <div className="message receivedMsg imgWeb">
                              <a href={message.value} target="_blank" rel="noreferrer">
                                <img
                                  src={message.value}
                                  alt="image"
                                  className="web-ke"
                                />
                              </a>
                              <pre
                                dangerouslySetInnerHTML={{
                                  __html: message?.received,
                                }}
                              ></pre>
                            </div>
                          ) : (
                            <div className="message receivedMsg">
                              <pre
                                dangerouslySetInnerHTML={{
                                  __html: message.received,
                                }}
                              ></pre>
                            </div>
                          )}
                          <div
                            className={
                              message?.services?.length > 0
                                ? "chatBoxBtnMain servicesElement"
                                : "chatBoxBtnMain"
                            }
                          >
                            {message.services?.map((service) => (
                              <button
                                key={service._id}
                                className="chatBoxBtn"
                                onClick={() =>
                                  handleSelectMessage(
                                    service.service,
                                    service._id
                                  )
                                }
                              >
                                {service.service}
                              </button>
                            ))}

                            {message.months?.map((month, index) => (
                              <button
                                key={index}
                                className="chatBoxBtn"
                                onClick={() => handleSelectMessageMonth(month)}
                              >
                                {month}
                              </button>
                            ))}

                            {message.button?.map((buttonObj, index) => (
                              <button
                                key={index}
                                className="chatBoxBtn"
                                onClick={() => {
                                  if (
                                    buttonObj.answer.startsWith("http://") ||
                                    buttonObj.answer.startsWith("https://")
                                  ) {
                                    // Open the link in a new tab
                                    // window.open(
                                    //   buttonObj.answer,
                                    //   "_blank",
                                    //   "noopener,noreferrer"
                                    // );
                                    handleSelectMessageButton(
                                      buttonObj.button,
                                      buttonObj.answer,
                                      "feedback"
                                    );
                                  } else {
                                    handleSelectMessageButton(
                                      buttonObj.button,
                                      buttonObj.answer
                                    );
                                  }
                                }}
                              >
                                {buttonObj.button}
                              </button>
                            ))}
                            <button
                              className="chatBoxBtn mt-1"
                              onClick={() => handleSelectMessage("Main Menu")}
                            >
                              Main Menu
                            </button>
                            <span className="smallest-text">
                              {" "}
                              {convertTimestamp(time)}
                            </span>
                          </div>
                        </div>
                      </>
                    )
                  )}
                </div>

                <div className="chatBoxBody rightChatBox">
                  {message.sent && (
                    <>
                      <span className="smallest-text text-right">User</span>
                      <p className="message sentMsg">{message.sent}</p>
                      <span className="smallest-text text-right">
                        {getCurrentTime()}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </>
          ))}
          {/* loading svg if we are waiting for response  */}
          {typingLoading ? (
            <>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 40 10"
                  width="40"
                  height="10"
                  fill="#555"
                >
                  <circle cx="5" cy="5" r="3">
                    <animate
                      attributeName="r"
                      from="3"
                      to="3"
                      begin="0s"
                      dur="0.8s"
                      values="3;1.5;3"
                      calcMode="linear"
                      repeatCount="indefinite"
                    />
                    <animate
                      attributeName="fill-opacity"
                      from="1"
                      to="1"
                      begin="0s"
                      dur="0.8s"
                      values="1;.5;1"
                      calcMode="linear"
                      repeatCount="indefinite"
                    />
                  </circle>
                  <circle cx="20" cy="5" r="1.5" fill-opacity="0.3">
                    <animate
                      attributeName="r"
                      from="1.5"
                      to="1.5"
                      begin="0.2s"
                      dur="0.8s"
                      values="1.5;3;1.5"
                      calcMode="linear"
                      repeatCount="indefinite"
                    />
                    <animate
                      attributeName="fill-opacity"
                      from="0.5"
                      to="0.5"
                      begin="0.2s"
                      dur="0.8s"
                      values=".5;1;.5"
                      calcMode="linear"
                      repeatCount="indefinite"
                    />
                  </circle>
                  <circle cx="35" cy="5" r="3">
                    <animate
                      attributeName="r"
                      from="3"
                      to="3"
                      begin="0.4s"
                      dur="0.8s"
                      values="3;1.5;3"
                      calcMode="linear"
                      repeatCount="indefinite"
                    />
                    <animate
                      attributeName="fill-opacity"
                      from="1"
                      to="1"
                      begin="0.4s"
                      dur="0.8s"
                      values="1;.5;1"
                      calcMode="linear"
                      repeatCount="indefinite"
                    />
                  </circle>
                </svg>
              </div>
              {lateResponseText !== "" && (
                <div style={{ fontSize: "10px" }}>{lateResponseText}</div>
              )}
            </>
          ) : null}
        </div>

        <div ref={messagesEndRef} />
      </div>
      <div className="preview-footer">
        <div className="type-text">
          <div className="textareaWeb">
            <textarea
              className="chat-widget-textarea"
              placeholder="Type your message here..."
              value={inputMessage}
              onChange={handleInputChange}
              onKeyDown={handleInputKeyDown}
            ></textarea>
          </div>
          <div>
            <img
              src={send}
              className="attach-icon"
              alt="send-icon"
              onClick={handleSendMessage}
            />
          </div>
        </div>

          

              <div className="uk-text-right"  >
                <p className="smallest-text powered">Powered by Convex Interactive </p>
              </div>
      </div>
    </div>
  );
};

export default ChatWidget;
